/* @flow */
import type {FetchAction} from './event';
import type {ClearAction, CreateAction} from './reservation';

type Action = FetchAction | ClearAction | CreateAction;
type State = {deliveryFee: Object, insuranceFee: Object, totalFees: number};
let initialState = { deliveryFee: {}, insuranceFee: {}, totalFees: 0};

export function fees(state: State = initialState, action:Action): State {
    if (action.type === "SET_FEE") {
        let newState = {...state};

        let totalFees = 0;

        if (action.fee.type === 'delivery') {
            newState.deliveryFee = action.fee.price;
        } else if (action.fee.type === 'insurance') {
            newState.insuranceFee = action.fee.price;
        }

        let deliveryFeeAmount  = Object.keys(newState.deliveryFee).length === 0 ? 0 : newState.deliveryFee.amount;
        let insuranceFeeAmount = Object.keys(newState.insuranceFee).length === 0 ? 0 : newState.insuranceFee.amount;

        totalFees += deliveryFeeAmount + insuranceFeeAmount;
        newState.totalFees = totalFees;

        return newState;
    } else if (action.type === "CLEAR_FEES") {
        return initialState;
    } else if (action.type === "RESERVATION_DATA_SET") {
        return initialState;
    } else if (action.type === "RESERVATION_CLEARED") {
        return initialState;
    } else if (action.type === "RESERVATION_CREATED") {
        return initialState;
    } else {
        return state;
    }
}
